export const API_URL: string = import.meta.env.VITE_NORDWORK_API_URL;

export const APP_MODE = import.meta.env.MODE as "development" | "production" | "stage";

export const IS_DEV: boolean = import.meta.env.DEV;

// The production build folds this to false, so Vite drops the MSW code from it.
export const IS_MOCK_MODE: boolean = IS_DEV || APP_MODE === "stage";

export const VITE_API_MOCKS: string | undefined = import.meta.env.VITE_API_MOCKS;

// The debug user picker on the dashboard works on the local dev server only, never on a deployed build.
export const IS_DEBUG_TOOLS_ENABLED: boolean = IS_DEV;
